import React from 'react';
import Button from '@mui/material/Button';
import {gray700, turquoise900} from '@/styles/palette';
import {Stack, Typography} from '@mui/material';

type Props = {
  onNext: () => void;
  ctaLabelText?: string;
  ctaText?: string;
};

export const PlanOptionsCTA: React.FC<Props> = ({
  onNext,
  ctaLabelText,
  ctaText,
}) => {
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Typography
        sx={{
          fontSize: '14px',
          color: gray700,
        }}>
        {ctaLabelText || 'Not sure yet?'}
      </Typography>
      <Button
        onClick={onNext}
        variant="text"
        disableRipple
        sx={{
          fontSize: '14px',
          fontWeight: '700',
          color: turquoise900,
          textTransform: 'none',
          padding: 0,
          justifyContent: 'flex-start',
        }}>
        {ctaText || 'Shop all plans'}
      </Button>
    </Stack>
  );
};
